<template>
  <header class="tw-mb-6">
    <div
      class="tw-flex tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-items-start lg:tw-justify-between"
    >
      <!-- Title block -->
      <div class="tw-min-w-0">
        <p
          v-if="eyebrow"
          class="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.12em] tw-text-surface-400 dark:tw-text-neutral-500"
        >
          {{ eyebrow }}
        </p>
        <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-2">
          <h1
            class="tw-font-heading tw-text-[1.6rem] tw-font-bold tw-leading-none tw-tracking-tight tw-text-secondary-900 dark:tw-text-neutral-50"
          >
            {{ title }}
          </h1>
          <slot name="status" />
        </div>
        <slot name="banner" />
      </div>

      <!-- Nav + actions -->
      <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-shrink-0 lg:tw-justify-end">
        <div
          v-if="showNav"
          class="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-surface-200 tw-bg-white tw-shadow-sm dark:tw-border-neutral-800 dark:tw-bg-neutral-950"
        >
          <button
            type="button"
            :disabled="!hasPrev"
            class="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-l-lg tw-text-secondary-600 tw-transition-colors hover:tw-bg-surface-100 hover:tw-text-secondary-900 disabled:tw-pointer-events-none disabled:tw-text-surface-300 dark:tw-text-neutral-400 dark:hover:tw-bg-neutral-800"
            :title="prevLabel"
            @click="emit('prev')"
          >
            <ChevronLeft class="tw-h-4 tw-w-4" />
          </button>
          <span class="tw-h-5 tw-w-px tw-bg-surface-200 dark:tw-bg-neutral-700" />
          <button
            type="button"
            :disabled="!hasNext"
            class="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-r-lg tw-text-secondary-600 tw-transition-colors hover:tw-bg-surface-100 hover:tw-text-secondary-900 disabled:tw-pointer-events-none disabled:tw-text-surface-300 dark:tw-text-neutral-400 dark:hover:tw-bg-neutral-800"
            :title="nextLabel"
            @click="emit('next')"
          >
            <ChevronRight class="tw-h-4 tw-w-4" />
          </button>
        </div>

        <slot name="actions" />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ChevronLeft, ChevronRight } from 'lucide-vue-next';

interface Props {
  title: string;
  eyebrow?: string;
  showNav?: boolean;
  hasPrev?: boolean;
  hasNext?: boolean;
  prevLabel?: string;
  nextLabel?: string;
}

withDefaults(defineProps<Props>(), {
  showNav: true,
  hasPrev: false,
  hasNext: false,
});

const emit = defineEmits<{
  prev: [];
  next: [];
}>();
</script>
